import styled from 'styled-components';
import { Base } from 'styled';

export const Container = styled(Base)`
  border-left: ${({ theme }) => `0.375rem solid ${theme.palette.primary.main}`};
  padding: 1.5rem;
  margin: 2.5rem 0;
`;
